import React from 'react';
import { Modal, Button } from 'antd';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

const TrialStatusModal = ({ open, onClose, type, expiryDate, productName = 'QuikTrade' }) => {
    const navigate = useNavigate();
    const isEndingSoon = type === 'ending';
    const title = isEndingSoon ? 'Plan Ending Soon' : 'Plan Expired';
    
    const formattedDate = moment(expiryDate).format('DD MMM YYYY');

    let expireText = `on ${formattedDate}`;
    if (moment(expiryDate).isSame(moment(), 'day')) {
        expireText = 'today';
    } else if (moment(expiryDate).isSame(moment().add(1, 'days'), 'day')) {
        expireText = 'tomorrow';
    }

    const message = isEndingSoon ? (
        <span>
            Your <span style={{fontWeight: 600}}>{productName} {productName.toLowerCase().includes('trial') ? '' : 'plan'} will expire {expireText}</span>. Renew your plan before the expiry date to avoid interruption.
        </span>
    ) : (
        <span>
            Your <span style={{fontWeight: 600}}>{productName} {productName.toLowerCase().includes('trial') ? '' : 'plan'} expired on {formattedDate}</span>. Renew your plan to restore access and continue using the platform.
        </span>
    );

    const handleRenew = () => {
        onClose();
        navigate('/pricing');
    };

    return (
        <Modal
            title={title}
            open={open}
            onCancel={onClose}
            footer={null}
            centered
        >
            <div style={{ padding: '10px 0' }}>
                <p style={{ fontSize: '1rem',  marginBottom: '24px' }}>
                    {message}
                </p>
                <Button 
                    type="primary" 
                    block 
                    size="large"
                    onClick={handleRenew}
                    style={{ 
                        height: '48px', 
                        fontWeight: 600,
                    }}
                >
                    Renew Now
                </Button>
            </div>
        </Modal>
    );
};

export default TrialStatusModal;
